import { render, staticRenderFns } from "./Pregraft.vue?vue&type=template&id=645c562e&scoped=true&"
import script from "./Pregraft.vue?vue&type=script&lang=js&"
export * from "./Pregraft.vue?vue&type=script&lang=js&"
import style0 from "./Pregraft.vue?vue&type=style&index=0&id=645c562e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c562e",
  null
  
)

export default component.exports